import Breadcrumb from 'components/Common/Breadcrumb'
import ConfirmationModal from 'components/Common/ConfirmationModal'
import PageLoader from 'components/Common/PageLoader'
import { status } from 'constants/ShipperInformationStatus'
import { useFormik } from 'formik'
import Seaprint from 'pages/Printfiles/Seaprint'
import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import SelectSearch from 'react-select-search'
import { useReactToPrint } from 'react-to-print'
import { Button, Card, CardBody, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap'
import { getSeaShipperInfo, getUserById, seaShipperInfoStatusUpdate } from 'store/actions'
import * as Yup from "yup"
import users_details from '../../assets/images/svg/enquiry/user-details.svg'

const SeaShipperInformation = () => {
    document.title = "Shipper Information Details | Glottis Logistics"

    const { shipperId } = useParams()
    const user = JSON.parse(localStorage.getItem("authUser"));
    const dispatch = useDispatch()
    const history = useHistory()
    const [selectedGroup, setselectedGroup] = useState('')
    const [statusModal, setStatusModal] = useState(false)
    const { shipperData, loader } = useSelector(state => ({
        shipperData: state?.GetSeaShipperInfo?.shipperInfo?.shipperInfo,
        loader: state.GetSeaShipperInfo.loader,
    })) 
    useEffect(() => {
        dispatch(getSeaShipperInfo(shipperId, history))
    }, [shipperId])

    const shipperForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            status: '',
            comment: ''
        },
        validationSchema: Yup.object({
            comment: Yup.string().required('Comment is required'),
            status: Yup.string().nullable().required('Status is required')
        }),
        onSubmit: (values) => {
            if (shipperForm.values?.status === 'completed') {
                setStatusModal(true)
            }
            else {
                setStatusModal(false)
                dispatchSI('no')
            }
        },
    })

    useEffect(() => {
        if (shipperData) setStatusValue(shipperData?.siStatusData?.shipperStatus)
    }, [shipperData])

    function setStatusValue(status) {
        if (status.toLowerCase() !== 'submitted' && status.toLowerCase() !== 'draft') {
            setselectedGroup(status);
            shipperForm.setFieldValue("status", status);
        } else {
            setselectedGroup('');
            shipperForm.setFieldValue("status", null);
        }
    }

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const dispatchSI = (status) => {
        const shipperInfo = {}
        const resetForm = shipperForm.resetForm();
        shipperInfo["status"] = shipperForm.values.status;
        shipperInfo["comments"] = shipperForm.values.comment;
        shipperInfo["shipperId"] = shipperId;
        shipperInfo["siStatusId"] = shipperData?.siStatusId;
        shipperInfo["completedStatus"] = status;
        dispatch(seaShipperInfoStatusUpdate(shipperInfo, resetForm, dispatch, getSeaShipperInfo, shipperId, history))
    }

    return (<>
        {loader ? <PageLoader /> : null}
        <div className="page-content shipper-details shipper-details-sea">
            <div className="container-fluid accordion-style">
                <Breadcrumb title="Enquiries" dashurl="/enquiries" breadcrumbItem={`Shipper information details - Sea`} breadcrumbName="Shipper information details" />
                <div className='text-end mb-4'>
                    <div style={{ display: "none" }}> <Seaprint seaprint={componentRef} shipperData={shipperData} /></div>
                    <button
                        type="button"
                        className="primary-button btn btn-secondary"
                        onClick={handlePrint}
                    >Print
                    </button>
                </div>
                <Card className='mt-3'>
                    <CardBody>
                        <div className='avater d-flex'>
                            <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                                <img src={users_details} alt="" />
                            </div>
                            <p className='f-size-16 fw-600 mb-0'>User Details</p>
                        </div>
                        <Row>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Name</Label>
                                    <Label className='form-control d-flex align-items-center'>{shipperData?.userDetail?.firstName}{' '}{shipperData?.userDetail?.lastName} </Label>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Email</Label>
                                    <Label className='form-control d-flex align-items-center'><a href={`mailto:${"#"}`}>{shipperData?.userDetail?.email}</a></Label>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Phone number</Label>
                                    <Label className='form-control d-flex align-items-center'><a href={`tel:${"#"}`}>{shipperData?.userDetail?.phoneNumber}</a></Label>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Client code</Label>
                                    <Label className='form-control d-flex align-items-center'>{shipperData?.clientDetail?.clientCode}</Label>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Client Name</Label>
                                    <Label className='form-control d-flex align-items-center'>{shipperData?.clientDetail?.name}</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <Row className='mb-4'>
                            <Col md='4'>
                                <Label>Bill of lading number</Label>
                                <Label className='form-control d-flex align-items-center'>{shipperData?.billOfLoadingNumber}</Label>
                            </Col>
                            <Col md='4'>
                                <Label>Place of receipt</Label>
                                <Label className='form-control d-flex align-items-center'>{shipperData?.placeOfReceipt}</Label>
                            </Col>
                            <Col md='4'>
                                <Label>Port of loading</Label>
                                <Label className='form-control d-flex align-items-center'>{shipperData?.portOfLoading}</Label>
                            </Col>
                        </Row>
                        <Row className='mb-4'>
                            <Col md='4'>
                                <Label>Vessel & voy</Label>
                                <Label className='form-control d-flex align-items-center'>{shipperData?.vesselAndVoy}</Label>
                            </Col>
                            <Col md='4'>
                                <Label>Port of discharge</Label>
                                <Label className='form-control d-flex align-items-center'>{shipperData?.portOfDischarge}</Label>
                            </Col>
                            <Col md='4'>
                                <Label>Port of delivery</Label>
                                <Label className='form-control d-flex align-items-center'>{shipperData?.portOfDelivery}</Label>
                            </Col>
                        </Row>
                        <Row className='mb-4'>
                            <Col md='6'>
                                <Label>Shipper</Label>
                                <Input type='textarea' className='textarea col-first' disabled value={shipperData?.shipper}></Input>
                            </Col>
                            <Col md='6'>
                                <Label>Consignee</Label>
                                <Input type='textarea' className='textarea' disabled value={shipperData?.consignee}></Input>
                            </Col>
                        </Row>
                        <Row className={shipperData?.notifyPartyTo ? 'mb-4' : ''}>
                            <Col md='6'>
                                <Label>Notify party</Label>
                                <Input type='textarea' className='textarea col-first' disabled value={shipperData?.notify} />
                            </Col>
                            <Col md='6'>
                                <Label>Destination agent details</Label>
                                <Input type='textarea' className='textarea' disabled value={shipperData?.destinationAgentDetails} />
                            </Col>
                        </Row>
                        {shipperData?.notifyPartyTo &&
                            <Row>
                                <Col md='6'>
                                    <Label>Other than notify party</Label>
                                    <Input type='textarea' className='textarea col-first' disabled value={shipperData?.notifyPartyTo} />
                                </Col>
                            </Row>
                        }
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <h5 className='mb-4'>Container details</h5>
                        {shipperData?.packageDetails?.map((item, index) => (
                            <div className='card' key={index}>
                                <div className='card-body'>
                                    <Row>
                                        <Col md='8'>
                                            <Row className='mb-4'>
                                                <Col md='6'>
                                                    <div className='form-group'>
                                                        <Label>Container number or type</Label>
                                                        <Label className='form-control d-flex align-items-center'>{item?.containerNumberOrType}</Label>
                                                    </div>
                                                </Col>
                                                <Col md='6'>
                                                    <div className='form-group'>
                                                        <Label>Number of packages</Label>
                                                        <Label className='form-control d-flex align-items-center'>{item?.noOfPkgs}</Label>

                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md='4'>
                                                    <div className='form-group'>
                                                        <Label>Gross weight (kg)</Label>
                                                        <Label className='form-control d-flex align-items-center'>{item?.grossWeight}</Label>

                                                    </div>
                                                </Col>
                                                <Col md='4'>
                                                    <div className='form-group'>
                                                        <Label>Net weight (kg)</Label>
                                                        <Label className='form-control d-flex align-items-center'>{item?.netWeight}</Label>

                                                    </div>
                                                </Col>
                                                <Col md='4'>
                                                    <div className='form-group'>
                                                        <Label>CBM</Label>
                                                        <Label className='form-control d-flex align-items-center'>{item?.CBM}</Label>

                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md='4'>
                                            <div className='form-group'>
                                                <Label>Description of goods</Label>
                                                <Input type='textarea' className='textarea' disabled value={item?.descriptionOfTheGoods} />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        ))}
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <Row>
                            <Col md='6'>
                                <Label>Marks & numbers</Label>
                                <Input type='textarea' className='textarea' disabled value={shipperData?.marksAndNumbers} />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {((user?.user?.role === 'ADMIN' || user?.user?.role === 'SUPER_ADMIN') && (shipperData?.siStatusData?.shipperStatus !== 'completed')) ?
                    <Card>
                        <CardBody>
                            <Form
                                className="needs-validation"
                                encType="multipart/form-data"
                                onSubmit={e => {
                                    e.preventDefault()
                                    shipperForm.handleSubmit()
                                    return false
                                }}>
                                <Row>
                                    <Col md={6}>
                                        <p className='mb-2'>
                                            <Label>Current status :</Label> <span className='text-uppercase'>{shipperData?.siStatusData?.shipperStatus}</span>
                                        </p>
                                    </Col>
                                </Row>
                                {/* current admin comments need to be hide when empty */}
                                {shipperData?.siStatusData?.comments &&
                                    <Row>
                                        <Col md={6} className='mb-3'>
                                            <p className='mb-0'>
                                                <Label className='mb-0'>Current admin comments :</Label> {shipperData?.siStatusData?.comments}
                                            </p>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col md="4">
                                        <FormGroup className="mb-3">
                                            <Label>Status<span>*</span></Label>
                                            <div className={`position-relative`}>
                                                <SelectSearch
                                                    options={(status)}
                                                    search={true}
                                                    name="status"
                                                    value={selectedGroup}
                                                    onChange={(e) => {
                                                        setStatusValue(e)
                                                    }}
                                                    onBlur={shipperForm.handleBlur}
                                                    invalid={
                                                        shipperForm.touched.status && shipperForm.errors.status ? true : false
                                                    }
                                                />
                                                <div className="select-down-arrow">
                                                    <i className="bx bx-chevron-down"></i>
                                                </div>
                                                {shipperForm.touched.status && shipperForm.errors.status ? (
                                                    <span className="role-error invalid-feedback">{shipperForm.errors.status}</span>
                                                ) : null}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Label className='mt-3'>Comments<span>*</span></Label>
                                <Row>
                                    <Col md={4}>
                                        <Input
                                            name="comment"
                                            type="textarea"
                                            className="form-control comment"
                                            onChange={shipperForm.handleChange}
                                            onBlur={shipperForm.handleBlur}
                                            value={shipperForm.values.comment || ""}
                                            invalid={shipperForm.touched.comment && shipperForm.errors.comment ? true : false}
                                        />
                                    </Col>
                                </Row>
                                {shipperForm.touched.comment &&
                                    shipperForm.errors.comment ? (
                                    <FormFeedback type="invalid">
                                        {shipperForm.errors.comment}
                                    </FormFeedback>
                                ) : null}
                                <div className='d-flex action-btn'>
                                    <Button type='submit' className='mt-3 rounded-pill me-3 primary-button '>Submit</Button>
                                    <Button type='button' onClick={() => history.push('/enquiries')} className='mt-3 rounded-pill secountry-btn'>Back</Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card> :
                    <div className='my-3 text-center'>
                        <Button type='button' onClick={() => history.push('/enquiries')} className='rounded-pill primary-button'>Back</Button>
                    </div>
                }
            </div>
            {/* while changing si status to completed, the corresponding enquiry status status will change if we click confirm */}
            <ConfirmationModal
                okButton={() => {
                    dispatchSI('yes')
                    setStatusModal(false)
                }}
                cancelButton={() => {
                    // dispatchSI('no')
                    setStatusModal(false);
                }}
                title={'Information'}
                setStatusModal={setStatusModal}
                statusModal={statusModal}
                butttonName={"Yes"}
                cancelBtnName={"No"}
                content={<p>Since you are updating the status as completed for shipper information, it will complete the enquiry automatically.</p>}
                />
        </div >
    </>
    )
}

export default SeaShipperInformation